import React from "react";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

class DynamicTextField extends React.Component {
  render() {
    let field = this.props.field;

    var helpTextArray = [];
    if (field.HelpText)
    {
      helpTextArray = field.HelpText.toString().split("<br>");
    }

    return (
        <>
        <fieldset className="entity-fieldset">
          <Typography component="legend" color="primary">
            <legend>
              {field.IsMandatory ? "*" : ""}
              {field.FieldName}
            </legend>
          </Typography>
          {
            helpTextArray.map(line => <p key={helpTextArray.indexOf(line)}>{line}</p>)
          }
          <TextField
            name={field.FieldCode}
            required={field.IsMandatory}
            disabled={field.IsReadonly}
            defaultValue={field.Value}
            onChange={this.props.eventHandle}
            error={this.props.fieldError ? true : false}
            fullWidth
            variant="filled"
            margin="none"
            inputProps={this.props.fieldProps}
            multiline = {field.IsMultiLine}
            rows={6}
            rowsMax={10}
          />
          <Typography variant="body2" color="error">
            {this.props.fieldError}
          </Typography>
        </fieldset>
      </>
    );
  }
}

export default DynamicTextField;
